import { HttpContextToken } from '@angular/common/http';

export const BYPASS_TOAST = new HttpContextToken<boolean>(() => false);
